<template>
  <div class="company-bd tb" v-if="funcView.partner_company_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="onAddCompany()" v-if="funcView.partner_company_add" >{{funcView.partner_company_add}}</el-button>
        </el-form-item>
        <el-form-item
            style="float: right; margin-right: 0"
            v-if="funcView.partner_company_export"
          >
            <el-button
              class="table-set"
              style="vertical-align: top"
              v-repeat
              @click="exportTable('crmPartnerExport', {...formSearch,tableCode})"
            ><i class="icon icon-daochu"></i></el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right"
          :style="{ marginRight: !funcView.partner_company_export ? '0' : '' }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="$t('crm_serviceCompany_cn.fwgsmc')"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="onPageChange({ page: 1 })"
            style="width: 280px;"
          >
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_serviceCompany_cn.ERPbian_hao')">
          <el-input v-model="formSearch.partnerCode" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_serviceCompany_cn.yyzzbh')">
          <el-input v-model="formSearch.businessLicense" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_serviceCompany_cn.chuang_jian_gong_si')">
          <el-input v-model="formSearch.createOrgName" style="width:100%;"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        v-loading="isLoading"
        :data="companyList"
        :column="tableColumn"
        height="100%"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
         :slots="['partnerName','action']"
      >
      <template v-slot:partnerName="scope">
          <div class="cell-link" v-if="funcView.partner_company_view"  @click="jump('/distributor/serviceCompany/detail',{ parentPath: $route.path,companyId: scope.row.partnerId, bizType: scope.row.partnerType })">{{ scope.row.partnerName }}</div>
          <div v-else >{{ scope.row.partnerName }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button
            type="text"
            size="mini"
            @click="onEditCompany(scope.row)"
            v-if="funcView.partner_company_edit"
          >{{funcView.partner_company_edit}}</el-button>

          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState===1 && funcView.partner_company_disable">{{funcView.partner_company_disable}}</el-button>
          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState===0 && funcView.partner_company_enable">{{funcView.partner_company_enable}}</el-button>

          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 修改密码 -->
              <el-dropdown-item v-if="funcView.partner_company_change_password"  @click.native="editPassword(scope.row)">
                {{funcView.partner_company_change_password}}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 更换管理员 -->
              <el-dropdown-item v-if="funcView.partner_company_change_manager" @click.native="editAdministrators(scope.row)">
                {{ funcView.partner_company_change_manager }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 实名认证审批 -->
              <el-dropdown-item v-if="funcView.partner_company_approval && scope.row.realNameState===1 && scope.row.verifyMethod===3 && $store.state.userInfo.bizType === 'HQ'" @click.native="jump('/distributor/serviceCompany/verified',{parentPath: $route.path,companyId: scope.row.partnerId})">
                {{ funcView.partner_renter_approval }}{{ showMore(scope.row) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 跟换管理员-->
    <company-administrators-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :data="dialogData"
      @success="getCompanyList"
      @close="dialogVisible = false"
    ></company-administrators-dialog>
    <!-- 修改管理员密码 -->
    <company-password-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      :data="dialogData1"
      @close="dialogVisible1 = false"
    ></company-password-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import companyPasswordDialog from '@/pages/crm/components/partnerCommon/partner_password_dialog';
import companyAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'serviceCompany',
  mixins: [resetFormSearchMixins],
  components: { companyPasswordDialog, companyAdministratorsDialog },
  data() {
    return {
      tableCode: 'crm_company',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerCode: '',
        businessLicense: '',
        createOrgName: '',
        // partnerType: ['SC', 'JV_SC', 'JV'] // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
        childOrgType: 'JV,SC'
      },
      totalRows: null,
      isLoading: false,
      companyList: [],
      // 更换管理员
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 修改密码
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      link: null
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getCompanyList();
  },
  // activated() {
  //   this.getCompanyList();
  // },
  methods: {
    onAddCompany() {
      this.clearTagByKeep('company_item');
      this.jump('/redirect/distributor/serviceCompany/add', { parentPath: '/distributor/serviceCompany' });

    },
    onEditCompany(row) {
      this.clearTagByKeep('company_item');
      this.jump('/redirect/distributor/serviceCompany/edit', { parentPath: '/distributor/serviceCompany', companyId: row.partnerId, partnerOrgId: row.partnerOrgId });

    },
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    getCompanyList: function () {
      this.isLoading = true;
      this.$getJSON(apis.partnerPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          this.companyList = res.data.list;
          this.totalRows = res.data.total;
        }
      });
    },
    // 更换管理员
    editAdministrators: function (row) {
      this.dialogData = row;
      this.dialogModel.title = this.$t('crm_serviceCompany_cn.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    // 修改密码
    editPassword: function (row) {
      this.dialogData1 = row;
      this.dialogModel1.title = this.$t('crm_serviceCompany_cn.xgglymm');
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
    },
    // 禁用启用
    updateState: function ({ partnerState, partnerId }) {
      let tips;
      if (partnerState === 1) {
        tips = this.$t('crm_serviceCompany_cn.nqdyjydqfwgsm');
        partnerState = 0;
      } else {
        tips = this.$t('crm_serviceCompany_cn.nqdyqydqfwgsm');
        partnerState = 1;
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.partnerUpdateState, {
            partnerState, partnerId
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getCompanyList();
          });
        })
        .catch(() => {});
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      // if (!this.formSearch.partnerType.length) {
      //   this.formSearch.partnerType = ['SC', 'JV_SC'];
      // }
      this.getCompanyList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getCompanyList();
    }
  }
};
</script>

<style lang="scss">
.company-bd {
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
